const Filtering = () => {
    var Isotope = require('isotope-layout');
    var jQueryBridget = require('jquery-bridget');
    var imagesLoaded = require('imagesloaded');

    // Register Isotope and imagesLoaded with jQuery
    jQueryBridget('isotope', Isotope, $);
    jQueryBridget('imagesLoaded', imagesLoaded, $);

    // Initialize Isotope for portfolio items
    var $grid = $('#filter-content');

    // Wait until all images are loaded before initializing Isotope for portfolio items
    $grid.imagesLoaded(function () {
        $grid.isotope({
            itemSelector: '.portfolio__item--sm',
            layoutMode: 'fitRows',
            transitionDuration: '0.5s',
        });
    });

    // Store current active filter for portfolio items
    var currentFilter = '*'; // No filter applied initially, show all

    // Filter functionality for portfolio items
    $('.filters').on('click', '.filter__item', function (event) {
        var $button = $(event.currentTarget);
        var filterValue = $button.attr('data-filter');

        if (currentFilter === filterValue) {
            filterValue = '*';  // Reset the filter
            currentFilter = '*'; 
        } else {
            currentFilter = filterValue; 
        }

        // Disable transitions temporarily to prevent layout shifts
        $grid.isotope('option', { transitionDuration: 0 });

        // Set filter for Isotope
        $grid.isotope({ filter: filterValue });

        // Re-enable transitions after filtering
        setTimeout(() => {
            $grid.isotope('option', { transitionDuration: '0.5s' });
            triggerImageReveal();
        }, 100);
    });

    // Change is-checked class on buttons for portfolio items
    $('.button-group').each(function (i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', '.filter__item', function (event) {
            var $button = $(event.currentTarget);

            if ($button.hasClass('is-checked')) {
                $button.removeClass('is-checked');
            } else {
                $buttonGroup.find('.is-checked').removeClass('is-checked');
                $button.addClass('is-checked');
            }
        });
    });

    // Trigger image reveal animation
    function triggerImageReveal() {
        setTimeout(() => {
            $('.js-image-reveal').each(function () {
                if ($(this).isInViewport()) {
                    $(this).addClass('o-image-reveal');
                }
            });
        }, 500);
    }
};

export { Filtering };
